var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import Watch from './Watch';
import { isComputedValue } from './utils';
export var Reaction = function (_Watch) {
  _inherits(Reaction, _Watch);
  function Reaction(dependencies, cb) {
    _classCallCheck(this, Reaction);
    var _this = _possibleConstructorReturn(this, (Reaction.__proto__ || Object.getPrototypeOf(Reaction)).call(this, 'Reaction'));
    _this.dependencies = dependencies;
    _this.cb = cb;
    _this.getter = null;
    _this.context = null;
    return _this;
  }
  _createClass(Reaction, [{
    key: 'initialize',
    value: function initialize() {
      var _this2 = this;
      this.context = this.controller.createContext();
      this.getter = function (tag) {
        return tag.getValue(_this2.context);
      };
      this.controller.dependencyStore.updateEntity(this, null, this.createDependencyMap());
      return this;
    }
  }, {
    key: 'createDependencyMap',
    value: function createDependencyMap() {
      var _this3 = this;
      return this.controller.createDependencyMap(Object.keys(this.dependencies).map(function (key) {
        return _this3.dependencies[key];
      }), null, this.modulePath);
    }
  }, {
    key: 'onUpdate',
    value: function onUpdate() {
      var _this4 = this;
      this.executedCount++;
      if (this.controller.devtools) {
        this.controller.devtools.sendWatchMap([], [], 0, 0);
      }
      this.cb(Object.keys(this.dependencies).reduce(function (currentDeps, key) {
        currentDeps[key] = _this4.dependencies[key].getValue(_this4.context);
        if (isComputedValue(currentDeps[key])) {
          currentDeps[key] = currentDeps[key].getValue();
        }
        return currentDeps;
      }, {
        get: this.getter
      }));
    }
  }]);
  return Reaction;
}(Watch);
export default (function (dependencies, cb) {
  if (!cb) {
    cb = dependencies;
    dependencies = {};
  }
  return new Reaction(dependencies, cb);
});